<template>
    <div class="card flex-md-row">
        <div class="card-body d-flex flex-column align-items-start py-2 px-3">
            <div class="d-flex flex-row align-items-center justify-content-start w-100">
                <div class="d-flex flex-column justify-content-between mr-3">
                    <span class="badge badge-primary mb-2">
                        {{ order }}
                    </span>
                    <span v-if="service" class="badge" :class="classServiceCode">
                        {{ serviceCode }}
                    </span>
                </div>
                <div class="w-100">
                    <div class="d-flex flex-row align-items-center justify-content-between w-100  mb-1">
                        <strong class="d-inline-block text-info text-break">
                            {{ title }}
                        </strong>
                        <i
                            v-if="!readonlyForm"
                            class="cursor-pointer fa fa-times close"
                            @click.prevent="removeResource">
                        </i>
                    </div>
                    <p class="small mb-0 text-break" v-if="name">
                        {{ name }}
                    </p>
                    <form class="custom-parameters" v-if="filteredCustomParameters.length">
                        <p class="mb-0 mt-3 small"><strong>{{ $t(`global.resources.items.resource.custom_parameters`) }}</strong></p>
                        <hr class="mt-0 mb-2"/>
                        <div class="form-group row mb-0 small"
                            v-for="param in filteredCustomParameters"
                            :key="`parameter-${param.key}`">
                            <label :for="`${itemId}-parameter-${param.key}`" class="col-sm-auto col-form-label">{{ param.label }}</label>
                            <div class="col-sm d-flex align-items-center">
                                <template v-if="param.type == 'checkbox'">
                                    <input class="form-check-input position-static"
                                        :id="`${itemId}-parameter-${param.key}`"
                                        type="checkbox"
                                        :checked="param.value"
                                        :false-value="false"
                                        :true-value="true"
                                        @change="(evt) => onChange(evt.target.checked, param)">
                                </template>
                                <template v-else>
                                    <input type="text" class="form-control form-control-sm" :value="param.value" @input="(evt) => onChange(evt.target.value, param)" />
                                </template>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OgcMixin from '../mixins/OgcMixin';
import { toCamelCase, uniqueId } from '@config/utils';

export default {
    name: 'ResourceItemSelected',
    mixins: [
        OgcMixin
    ],
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        readonlyForm: {
            type: Boolean,
            default: true,
        },
        pivotKey: {
            type: String,
            default: '',
        },
        wmsCustomParameters: {
            type: Array,
            default: () => {
                return [
                    {
                        key: "transparent",
                        label: "Transparente",
                        value: true,
                        type: 'checkbox',
                        status: true
                    },
                    {
                        key: "time",
                        value: 'yyyy-MM-ddThh:mm:ss.SSSZ',
                        type: 'text',
                        status: false
                    },
                    {
                        key: "tiled",
                        label: "Tiles",
                        value: true,
                        type: 'checkbox',
                        status: true
                    },
                ];
            }
        }
    },
    data() {
        return {
            item: {},
            parametersKey: 'parameters',
        }
    },
    mounted() {
        this.setDefaultCustomParameters();
    },
    computed: {
        itemId() {
            return this.item?.id ?? uniqueId();
        },
        service() {
            return this.item?.service;
        },
        serviceName() {
            return this.service?.title;
        },
        serviceCode() {
            return this.getServiceCode(this.service)
        },
        classServiceCode() {
            return this.getClassServiceCode(this.service)
        },
        title() {
            return this.item?.title;
        },
        name() {
            return this.item?.name ?? this.item?.layers;
        },
        abstract() {
            return this.item?.abstract;
        },
        pivotData() {
            return this.pivotKey in this.item ? this.item[this.pivotKey] : {};
        },
        order() {
            return this.pivotData?.order ?? 1;
        },
        customParameters() {
            return this.pivotData[this.parametersKey] ?? null;
        },
        isWMS() {
            return this.serviceCode.toLowerCase() == 'wms';
        },
        filteredCustomParameters() {
            return this.isWMS ? this.wmsCustomParameters
            .filter(item => !!item.status)
            .map(item => {
                item.label = item.label ?? toCamelCase(item.key, true);
                let currentParam = this.item[this.pivotKey] && this.item[this.pivotKey][this.parametersKey] ?
                    this.item[this.pivotKey][this.parametersKey].find(_param => _param.key == item.key) : {};
                item.value = currentParam?.value ?? item.value;
                item.value = (/^(true|false)$/i).test(String(item.value)) ? String(item.value).toLowerCase() === 'true' : item.value;
                return item;
            }) : [];
        }
    },
    methods: {
        setDefaultCustomParameters() {
            if(this.isWMS) {
                if(!this.customParameters) {
                    if(!this.pivotKey in this.item) {
                        this.$set(this.item, this.pivotKey, {});
                    }
                    this.$set(this.item[this.pivotKey], this.parametersKey, []);
                }

                this.filteredCustomParameters.map(param => {
                    if(!this.item[this.pivotKey][this.parametersKey].find(_param => _param.key == param.key)) {
                        this.item[this.pivotKey][this.parametersKey].push({key: param.key, value: param.value});
                    }
                });
            }
        },
        onChange(value, param) {
            let item = this.item[this.pivotKey] && this.item[this.pivotKey][this.parametersKey] ? this.item[this.pivotKey][this.parametersKey].find(_param => _param.key == param.key) : null;
            if(item) {
                item.value = value;
            }
        },
        removeResource() {
            if(this.readonlyForm){
                return;
            }
            this.$emit('removeResource');
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler: function(value) {
                this.item = value;
            }
        },
        item: {
            deep: true,
            handler: function(value) {
                this.$emit('input', value);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.close {
    font-size: 1.1rem;
}
.custom-parameters {
    label {
        line-height: 1;
    }

    .form-check-input {
        opacity: 1;
        margin-top: inherit;
        margin-bottom: inherit;
        pointer-events: inherit;
    }
}
</style>